import { render, staticRenderFns } from "./DetailCard.vue?vue&type=template&id=f525f9e0&"
import script from "./DetailCard.vue?vue&type=script&lang=ts&"
export * from "./DetailCard.vue?vue&type=script&lang=ts&"
import style0 from "./DetailCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports